import { render, staticRenderFns } from "./FuSpeedDialButton.vue?vue&type=template&id=ffb22086&functional=true&"
import script from "./FuSpeedDialButton.vue?vue&type=script&lang=js&"
export * from "./FuSpeedDialButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports